import styled from 'styled-components';

const MyDiv = styled.div`
.card-wrapper {
    padding: 5px 14px 5px 14px
    width:437px;
    height:auto;
    background-color:#F0F5F1;
  }

.birthday-list {
  max-height: 280px;
  overflow-y: auto;
  padding-right: 6px;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent; 
  transition: scrollbar-color 0.3s ease-in-out;
}

.birthday-list:hover {
  scrollbar-color: gray #eae6e6ff;
}

.birthday-list::-webkit-scrollbar {
  width: 6px;
}

.birthday-list::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 6px;
  transition: background 0.3s ease-in-out;
}

.birthday-list:hover::-webkit-scrollbar-thumb {
  background: #a0aec0; 
}

.birthday-list::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 6px;
}

.birthday-row {
    background-color: #ffffff;
    border-radius: 8px;
    height:47px;
    padding:10px 10px 10px 12px;
    margin-bottom: 8px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  }

.react-calendar {
    font-family: 'Poppins', sans-serif;   
    width: 220px;
    max-width: 100%;
    font-size: 12px;
    border: none;
    border-radius: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
  }

.react-calendar__tile {
    padding: 6px 0;
  }

.react-calendar__navigation button {
    min-width: 28px;
    font-size: 12px;
  }

.react-calendar__month-view__days__day--weekend {
    color: #ff6b6b;
  }
`;

export default MyDiv;